import React from 'react';
import FilterDropdown from '../../../shared/components/filter/FilterDropdown';
import { DepartmentDto } from '../../../../types/department.types';
import { Store } from '../../../../types/shop.types';
import { UserStatus, BloodType } from '../../../../types/user.types';
import { useTranslation } from 'react-i18next';

interface EmployeeFiltersProps {
  departments: DepartmentDto[];
  shops: Store[];
  selectedDepartment: string;
  selectedShop: string;
  selectedStatus: string | UserStatus;
  selectedBloodType: string;
  onDepartmentChange: (departmentId: string) => void;
  onShopChange: (shopId: string) => void;
  onStatusChange: (status: string | UserStatus) => void;
  onBloodTypeChange: (bloodType: string) => void;
  onReset: () => void;
}

const EmployeeFilters: React.FC<EmployeeFiltersProps> = ({
  departments,
  shops,
  selectedDepartment,
  selectedShop,
  selectedStatus,
  selectedBloodType,
  onDepartmentChange,
  onShopChange,
  onStatusChange,
  onBloodTypeChange,
  onReset
}) => {
  const { t } = useTranslation();
  const filterGroups = [
    {
      label: t('employees.filters.department'),
      type: 'select' as const,
      value: selectedDepartment,
      onChange: onDepartmentChange,
      options: [
        { value: 'all', label: t('employees.filters.allDepartments') },
        ...departments?.map(dept => ({
          value: dept.id.toString(),
          label: dept.name
        }))
      ]
    },
    {
      label: t('employees.filters.shop'),
      type: 'select' as const,
      value: selectedShop,
      onChange: onShopChange,
      options: [
        { value: 'all', label: t('employees.filters.allShops') },
        ...shops?.map(shop => ({
          value: shop.id.toString(),
          label: shop.name
        }))
      ]
    },
    {
      label: t('employees.filters.status'),
      type: 'select' as const,
      value: selectedStatus,
      onChange: onStatusChange,
      options: [
        { value: 'all', label: t('employees.filters.allStatuses') },
        { value: 'active', label: t('employees.filters.active') },
        { value: 'resigned', label: t('employees.filters.resigned') }
      ]
    },
    {
      label: 'Kan Grubu',
      type: 'select' as const,
      value: selectedBloodType,
      onChange: onBloodTypeChange,
      options: [
        { value: 'all', label: 'Tümü' },
        { value: 'A+', label: 'A+' },
        { value: 'A-', label: 'A-' },
        { value: 'B+', label: 'B+' },
        { value: 'B-', label: 'B-' },
        { value: 'AB+', label: 'AB+' },
        { value: 'AB-', label: 'AB-' },
        { value: 'O+', label: 'O+' },
        { value: 'O-', label: 'O-' },
        { value: 'Bilinmiyor', label: 'Bilinmiyor' }
      ]
    }
  ];

  return (
    <FilterDropdown
      groups={filterGroups}
      onReset={onReset}
      buttonType="primary"
    />
  );
};

export default EmployeeFilters; 